<section class="space-y-6">
  <header class="flex flex-wrap items-center justify-between gap-4">
    <div>
      <p class="text-xs uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
        {{ i18n.translate('user.page.subtitle') }}
      </p>
      <h2 class="mt-1 text-2xl font-semibold text-slate-900 dark:text-slate-100">
        {{ i18n.translate('user.page.title') }}
      </h2>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <button nz-button nzType="default" (click)="searchTerm=''; onSearchTermChange()">
        {{ i18n.translate('user.search.reset') }}
      </button>
      <button nz-button nzType="default" (click)="getUsers()">
        {{ i18n.translate('user.actions.refresh') }}
      </button>
      <button nz-button nzType="primary" (click)="openCreate()">
        {{ i18n.translate('user.actions.add') }}
      </button>
    </div>
  </header>

  <div class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900">
    <div class="grid gap-4 lg:grid-cols-[1.7fr_0.9fr_auto] lg:items-end">
      <label class="block">
        <span class="text-sm font-medium text-slate-600 dark:text-slate-300">
          {{ i18n.translate('user.search.placeholder') }}
        </span>
        <input
          nz-input
          type="text"
          class="mt-2"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchTermChange()"
          [placeholder]="i18n.translate('user.search.placeholder')"
        />
      </label>
      <div class="flex flex-wrap items-center gap-2 lg:justify-end">
        <button nz-button nzType="default" (click)="searchTerm=''; onSearchTermChange()">
          {{ i18n.translate('user.search.reset') }}
        </button>
      </div>
    </div>
  </div>

  <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
    <div class="border-b border-slate-200 bg-slate-50 px-5 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-400">
      {{ i18n.translate('user.page.tableTitle') }}
    </div>
    <nz-table
      #userTable
      [nzData]="filteredUsers"
      [nzFrontPagination]="true"
      [nzTotal]="filteredUsers.length"
      [nzPageSize]="_paging.pageSize"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="[5, 10, 20, 50]"
      [(nzPageIndex)]="_paging.pageIndex"
      [nzLoading]="_loading"
      [nzNoResult]="noResult"
      [nzSize]="'middle'"
    >
      <thead>
        <tr>
          <th>{{ i18n.translate('user.columns.name') }}</th>
          <th>{{ i18n.translate('user.columns.email') }}</th>
          <th>{{ i18n.translate('user.columns.company') }}</th>
          <th>{{ i18n.translate('user.columns.piva') }}</th>
          <th>{{ i18n.translate('user.columns.status') }}</th>
          <th class="text-right">{{ i18n.translate('user.columns.actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of userTable.data" class="hover:bg-slate-50 dark:hover:bg-slate-950">
          <td class="font-medium text-slate-900 dark:text-slate-100">
            <div class="flex items-center gap-3">
              <div class="flex h-11 w-11 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                {{ user.name.charAt(0) }}{{ user.lastName.charAt(0) }}
              </div>
              <div>
                <div class="text-sm font-semibold">{{ user.name }} {{ user.lastName }}</div>
                <div class="text-xs text-slate-500 dark:text-slate-400">{{ user.userKey }}</div>
              </div>
            </div>
          </td>
          <td class="text-slate-600 dark:text-slate-400">{{ user.email }}</td>
          <td class="text-slate-600 dark:text-slate-400">
            <div class="font-medium text-slate-700 dark:text-slate-300">{{ user.companyName }}</div>
            <div class="text-xs text-slate-500 dark:text-slate-400">{{ user.city }}</div>
          </td>
          <td class="text-slate-600 dark:text-slate-400">{{ user.piva }}</td>
          <td>
            <nz-tag [nzColor]="user.enabled ? 'green' : 'red'">
              {{ user.enabled ? i18n.translate('user.status.active') : i18n.translate('user.status.inactive') }}
            </nz-tag>
          </td>
          <td class="text-right">
            <div class="flex justify-end gap-2">
              <button nz-button nzType="default" (click)="openDetails(user)">
                {{ i18n.translate('user.actions.details') }}
              </button>
              <button nz-button nzType="default" (click)="openEdit(user)">
                {{ i18n.translate('user.actions.edit') }}
              </button>
              <button
                nz-button
                nzType="default"
                nzDanger
                nz-popconfirm
                [nzPopconfirmTitle]="i18n.translate('user.actions.deleteConfirm')"
                (nzOnConfirm)="deleteUser(user)"
              >
                {{ i18n.translate('user.actions.delete') }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #noResult>
      <div class="p-6 text-center text-sm text-slate-500">
        {{ i18n.translate('user.search.empty') }}
      </div>
    </ng-template>
  </div>
</section>

<nz-drawer
  [nzVisible]="isDrawerOpen"
  [nzWidth]="780"
  [nzTitle]="isEditMode ? i18n.translate('user.drawer.editTitle') : i18n.translate('user.drawer.detailsTitle')"
  (nzOnClose)="closeDrawer()"
>
  <ng-container *nzDrawerContent>
    <div class="user-drawer grid gap-6 lg:grid-cols-[1.1fr_1.6fr]">
      <div class="rounded-2xl border border-slate-200 bg-slate-50 p-5 text-sm dark:border-slate-800 dark:bg-slate-950">
        <div class="flex items-center justify-between">
          <h3 class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
            {{ i18n.translate('user.drawer.summary') }}
          </h3>
          <nz-tag [nzColor]="editModel.enabled ? 'green' : 'red'">
            {{ editModel.enabled ? i18n.translate('user.status.active') : i18n.translate('user.status.inactive') }}
          </nz-tag>
        </div>
        <div class="mt-5 flex items-center gap-3">
          <div class="flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
            {{ editModel.name.charAt(0) }}{{ editModel.lastName.charAt(0) }}
          </div>
          <div>
            <div class="text-base font-semibold text-slate-900 dark:text-slate-100">
              {{ editModel.name || '-' }} {{ editModel.lastName || '' }}
            </div>
            <div class="text-xs text-slate-500 dark:text-slate-400">{{ editModel.userKey || '-' }}</div>
          </div>
        </div>
        <dl class="mt-5 space-y-2">
          <div class="flex justify-between gap-3">
            <dt class="text-slate-500">{{ i18n.translate('user.fields.email') }}</dt>
            <dd class="text-slate-900 dark:text-slate-100">{{ editModel.email || '-' }}</dd>
          </div>
          <div class="flex justify-between gap-3">
            <dt class="text-slate-500">{{ i18n.translate('user.fields.company') }}</dt>
            <dd class="text-slate-900 dark:text-slate-100">{{ editModel.companyName || '-' }}</dd>
          </div>
          <div class="flex justify-between gap-3">
            <dt class="text-slate-500">{{ i18n.translate('user.fields.piva') }}</dt>
            <dd class="text-slate-900 dark:text-slate-100">{{ editModel.piva || '-' }}</dd>
          </div>
          <div class="flex justify-between gap-3" *ngIf="selectedUser">
            <dt class="text-slate-500">{{ i18n.translate('user.fields.licenseId') }}</dt>
            <dd class="text-slate-900 dark:text-slate-100">{{ editModel.licenseId || '-' }}</dd>
          </div>
          <div class="flex justify-between gap-3">
            <dt class="text-slate-500">{{ i18n.translate('user.fields.city') }}</dt>
            <dd class="text-slate-900 dark:text-slate-100">{{ editModel.city || '-' }}</dd>
          </div>
          <div class="flex justify-between gap-3">
            <dt class="text-slate-500">{{ i18n.translate('user.fields.enabled') }}</dt>
            <dd>
              <nz-tag [nzColor]="editModel.enabled ? 'green' : 'red'">
                {{ editModel.enabled ? i18n.translate('user.status.active') : i18n.translate('user.status.inactive') }}
              </nz-tag>
            </dd>
          </div>
        </dl>
      </div>

      <form nz-form class="space-y-4">
        <div class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <h3 class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
            {{ i18n.translate('user.drawer.editTitle') }}
          </h3>
          <div class="mt-5 space-y-4">
            <div class="grid gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.name') }}
                </label>
                <input nz-input [(ngModel)]="editModel.name" name="name" [disabled]="!isEditMode" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.lastName') }}
                </label>
                <input nz-input [(ngModel)]="editModel.lastName" name="lastName" [disabled]="!isEditMode" />
              </div>
            </div>

            <div>
              <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                {{ i18n.translate('user.fields.email') }}
              </label>
              <input nz-input [(ngModel)]="editModel.email" name="email" [disabled]="!isEditMode || !!selectedUser" />
            </div>

            <div>
              <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                {{ i18n.translate('user.fields.company') }}
              </label>
              <input nz-input [(ngModel)]="editModel.companyName" name="companyName" [disabled]="!isEditMode" />
            </div>

            <div class="grid gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.piva') }}
                </label>
                <input nz-input [(ngModel)]="editModel.piva" name="piva" [disabled]="!isEditMode" />
              </div>
              <div *ngIf="selectedUser">
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.licenseId') }}
                </label>
                <input nz-input [(ngModel)]="editModel.licenseId" name="licenseId" [disabled]="true" />
              </div>
            </div>

            <div class="grid gap-4 md:grid-cols-2" *ngIf="selectedUser">
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.licenseStart') }}
                </label>
                <input nz-input type="date" [(ngModel)]="licenseStart" name="licenseStart" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.licenseDuration') }}
                </label>
                <input nz-input type="number" min="1" [(ngModel)]="licenseDuration" name="licenseDuration" />
              </div>
            </div>

            <div class="grid gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.city') }}
                </label>
                <input nz-input [(ngModel)]="editModel.city" name="city" [disabled]="!isEditMode" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.province') }}
                </label>
                <input nz-input [(ngModel)]="editModel.province" name="province" [disabled]="!isEditMode" />
              </div>
            </div>

            <div class="grid gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.street') }}
                </label>
                <input nz-input [(ngModel)]="editModel.street" name="street" [disabled]="!isEditMode" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.zip') }}
                </label>
                <input nz-input [(ngModel)]="editModel.zip" name="zip" [disabled]="!isEditMode" />
              </div>
            </div>

            <div class="grid gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.state') }}
                </label>
                <input nz-input [(ngModel)]="editModel.state" name="state" [disabled]="!isEditMode" />
              </div>
              <div>
                <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-500">
                  {{ i18n.translate('user.fields.userKey') }}
                </label>
                <input nz-input [(ngModel)]="editModel.userKey" name="userKey" [disabled]="!isEditMode" />
              </div>
            </div>

            <div class="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-xs font-medium uppercase tracking-wide text-slate-500 dark:border-slate-800 dark:bg-slate-950">
              <span>{{ i18n.translate('user.fields.enabled') }}</span>
              <nz-switch
                [(ngModel)]="editModel.enabled"
                name="enabled"
                [nzDisabled]="!isEditMode"
                (ngModelChange)="selectedUser?.userId ? putChangeEnabled(selectedUser?.userId, $event) : null"
              ></nz-switch>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end gap-2 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <button
            *ngIf="selectedUser"
            nz-button
            nzType="default"
            type="button"
            (click)="postSendUserEmail(selectedUser.userId, editModel.email, editModel.userKey, licenseStart, licenseDuration)"
          >
            {{ i18n.translate('user.actions.sendEmail') }}
          </button>
          <button nz-button nzType="default" type="button" (click)="closeDrawer()">
            {{ i18n.translate('user.actions.cancel') }}
          </button>
          <button *ngIf="isEditMode" nz-button nzType="primary" type="button" (click)="saveUser()">
            {{ i18n.translate('user.actions.save') }}
          </button>
        </div>
      </form>
    </div>
  </ng-container>
</nz-drawer>
